import getTheeSixtyEvaluationState from '../state';

export default {
	// eslint-disable-next-line no-unused-vars
	RESET_TSE_STATE(state) {
		// eslint-disable-next-line no-param-reassign
		const initialState = getTheeSixtyEvaluationState();
		// eslint-disable-next-line no-param-reassign
		state.evaluationFlow = { ...initialState.evaluationFlow };
	},
	UPDATE_JOBS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.jobs = payload;
	},
	UPDATE_JOBS_AREAS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.jobAreas = payload;
	},
	UPDATE_SELECTED_AREAS_IDS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.evaluationFlow.selectedAreaIds = payload;
	},
	UPDATE_SELECTED_JOBS(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.evaluationFlow.selectedJobs = payload;
	},
	UPDATE_FLOW_CONFIGURATION(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.moduleConfiguration = payload;
	},
	UPDATE_CURRENT_STEP(state, payload) {
		// eslint-disable-next-line no-param-reassign
		state.evaluationFlow.currentStep = payload;
	},
};



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/store/evaluation/mutations.js